export default __webpack_public_path__ + "static/valik-bdc7b91d3b88de65847f5f1d78347546.webp";